// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__y8QYL","inputbox":"Box_inputbox__1w1FQ","locked":"Box_locked__2XeOp","correct":"Box_correct__2NrJI","incorrect":"Box_incorrect__10u2F"};